import React from "react";
import ab1 from "../../assets/production/brooks.jpg";
import ab2 from "../../assets/production/bilanpositif.jpg";
import ab3 from "../../assets/production/dolcevita.jpg";
import ab4 from "../../assets/production/fr-3eme.jpg";
import ab5 from "../../assets/production/fr-ecpyrose.jpg";
import ab6 from "../../assets/production/delahaye-sisters.jpg";
import ab7 from "../../assets/production/annees80-tubesretrouves.jpeg";
import ab8 from "../../assets/production/annees80-mieuxavant.jpeg";
import ab9 from "../../assets/production/09lestubesretrouves.jpg";
import ab10 from "../../assets/production/kannelle.jpg";
import ab11 from "../../assets/production/groupiedestars.jpg";
import logoSacem from "../../assets/logo/logosacem.png";

import "./index.css";

const TheProduction = (props) => {
  // Fonction pour empêcher les actions de copier, coller et glisser-déposer
  const preventDefaultActions = (e) => {
    e.preventDefault();
  };
  return (
    <div className="production" style={{ overflowX: "hidden" }} id="production">
      <h2 className="title" style={{ color: "white", marginBottom: "1rem" }}>
        DISCOGRAPHIE
      </h2>
      <div className="border max-w-[150px]"></div>
      <h4 className="production-meet">{/* test */}</h4>

      <div className="text-center max-w-15 italic font-semibold text-[20px] text-white  my-5">
        <h2 className="max-sm:text-[20px]">
          VFP propose un catalogue majoritairement francophone,{" "}
          <span>
            {" "}
            <br />
            composé de titres vintage des années 70-80 et de créations
            contemporaines.{" "}
          </span>
        </h2>
      </div>
      <div className="flex justify-center my-9">
        <ul className="flex gap-7 max-sm:flex-col max-lg:flex-col">
          <li className="flex flex-col items-center gap-3">
            <img
              className="max-w-[300px]"
              onContextMenu={preventDefaultActions} // Empêche le clic droit
              onDragStart={preventDefaultActions} // Empêche le glisser-déposer
              onMouseDown={preventDefaultActions} // Empêche d'autres actions de souris potentiellement indésirables
              src={ab1}
              alt=""
            />
            <p className="font-openSans text-[16px] max-sm:text-sm max-sm:text-center text-center font-bold text-white opacity-90 leading-6">
              Brooks
              <br />
              <span className="italic">What a paradise ! </span>(EP)
            </p>
            <span className="max-sm:mx-auto news-link">
              <a
                href="https://open.spotify.com/intl-fr/artist/0u5R4FYFVtfj4POuUwc5CW
"
                rel="noopener noreferrer"
                target="_blank"
              >
                Écouter
              </a>
            </span>
          </li>
          <li className=" flex flex-col items-center gap-3">
            <img
              className="max-w-[300px] "
              onContextMenu={preventDefaultActions} // Empêche le clic droit
              onDragStart={preventDefaultActions} // Empêche le glisser-déposer
              onMouseDown={preventDefaultActions} // Empêche d'autres actions de souris potentiellement indésirables
              src={ab2}
              alt=""
            />
            <p className="font-openSans text-[16px] max-sm:text-sm max-sm:text-center text-center font-bold text-white opacity-90 leading-6">
              Franck Fernandel
              <br />
              <span className="italic">Bilan Positif  </span>(Album)
            </p>
            <span className="max-sm:mx-auto news-link">
              <a
                href="https://open.spotify.com/intl-fr/album/19BbvJzsYkhODIaTpY47rW"
                rel="noopener noreferrer"
                target="_blank"
              >
                Écouter
              </a>
            </span>
          </li>
          <li className=" flex flex-col items-center gap-3">
            <img
              className="max-w-[300px] "
              onContextMenu={preventDefaultActions} // Empêche le clic droit
              onDragStart={preventDefaultActions} // Empêche le glisser-déposer
              onMouseDown={preventDefaultActions} // Empêche d'autres actions de souris potentiellement indésirables
              src={ab3}
              alt=""
            />
            <p className="font-openSans text-[16px] max-sm:text-sm max-sm:text-center text-center font-bold text-white opacity-90  leading-6">
              Franck Fernandel
              <br />
              <span className="italic">C’est toi ma dolce vita </span>(Album)
            </p>

            <div className="flex">
              <span className="max-sm:mx-auto news-link">
                <a
                  href="https://franckfernandel.lnk.to/cesttoimadolcevita"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Écouter
                </a>
              </span>
            </div>
          </li>
        </ul>
      </div>
      <div className="flex justify-center my-9">
        <ul className="flex gap-7 max-sm:flex-col max-lg:flex-col">
          <li className="flex flex-col items-center gap-3">
            <img
              className="max-w-[300px]"
              onContextMenu={preventDefaultActions} // Empêche le clic droit
              onDragStart={preventDefaultActions} // Empêche le glisser-déposer
              onMouseDown={preventDefaultActions} // Empêche d'autres actions de souris potentiellement indésirables
              src={ab4}
              alt=""
            />
            <p className="font-openSans text-[16px] max-sm:text-sm max-sm:text-center text-center font-bold text-white opacity-90 leading-6">
              Florent Richard
              <br />
              <span className="italic">3ème album </span>(Album)
            </p>
            <span className="max-sm:mx-auto news-link">
              <a
                href="https://open.spotify.com/intl-fr/album/3prUw3nqVVMzTXnakfSJ7p"
                rel="noopener noreferrer"
                target="_blank"
              >
                Écouter
              </a>
            </span>
          </li>
          <li className=" flex flex-col items-center gap-3">
            <img className="max-w-[300px] " src={ab5} alt="" />
            <p className="font-openSans text-[16px] max-sm:text-sm max-sm:text-center text-center font-bold text-white opacity-90 leading-6">
              Florent Richard
              <br />
              <span className="italic">Ecpyrose </span>(Album)
            </p>
            <span className="max-sm:mx-auto news-link">
              <a
                href="https://open.spotify.com/intl-fr/album/4qYw1OueqOF3KveklmW3rP"
                rel="noopener noreferrer"
                target="_blank"
              >
                Écouter
              </a>
            </span>
          </li>
          <li className=" flex flex-col items-center gap-3">
            <img
              className="max-w-[300px] "
              onContextMenu={preventDefaultActions} // Empêche le clic droit
              onDragStart={preventDefaultActions} // Empêche le glisser-déposer
              onMouseDown={preventDefaultActions} // Empêche d'autres actions de souris potentiellement indésirables
              src={ab6}
              alt=""
            />
            <p className="font-openSans text-[16px] max-sm:text-sm max-sm:text-center text-center font-bold text-white opacity-90 leading-6">
              Delahaye Sisters
              <br />
              <span className="italic">Gogo Lady </span>(EP)
            </p>
            <span className="max-sm:mx-auto news-link">
              <a
                href="https://open.spotify.com/intl-fr/artist/4PtXpeCErGyDYTgBXti5vh"
                rel="noopener noreferrer"
                target="_blank"
              >
                Écouter
              </a>
            </span>
          </li>
        </ul>
      </div>

      <div className="flex justify-center my-9">
        <ul className="flex gap-7 max-sm:flex-col max-lg:flex-col">
          <li className="flex flex-col items-center gap-3">
            <img
              className="max-w-[300px]"
              onContextMenu={preventDefaultActions} // Empêche le clic droit
              onDragStart={preventDefaultActions} // Empêche le glisser-déposer
              onMouseDown={preventDefaultActions} // Empêche d'autres actions de souris potentiellement indésirables
              src={ab7}
              alt=""
            />
            <p className="font-openSans text-[16px] max-sm:text-sm max-sm:text-center text-center font-bold text-white opacity-90 leading-6">
              Les Années 80
              <br /> Tubes retrouvés (Compilation)
            </p>
            <span className="max-sm:mx-auto news-link">
              <a
                href="https://www.fnac.com/a17282583/Album-Nouvel-album-CD-album"
                rel="noopener noreferrer"
                target="_blank"
              >
                Acheter
              </a>
            </span>
          </li>
          <li className=" flex flex-col items-center gap-3">
            <img
              className="max-w-[300px] "
              onContextMenu={preventDefaultActions} // Empêche le clic droit
              onDragStart={preventDefaultActions} // Empêche le glisser-déposer
              onMouseDown={preventDefaultActions} // Empêche d'autres actions de souris potentiellement indésirables
              src={ab8}
              alt=""
            />
            <p className="font-openSans text-[16px] max-sm:text-sm max-sm:text-center text-center font-bold text-white opacity-90  leading-6">
              Les Années 80
              <br /> C’était mieux avant - Vol.3 (Compilation)
            </p>
            <span className="max-sm:mx-auto news-link">
              <a
                href="https://www.fnac.com/a16057742/Collectif-Les-annees-80-c-etait-mieux-avant-Volume-3-CD-album"
                rel="noopener noreferrer"
                target="_blank"
              >
                Acheter
              </a>
            </span>
          </li>
          <li className=" flex flex-col items-center gap-3">
            <img
              className="max-w-[300px] "
              onContextMenu={preventDefaultActions} // Empêche le clic droit
              onDragStart={preventDefaultActions} // Empêche le glisser-déposer
              onMouseDown={preventDefaultActions} // Empêche d'autres actions de souris potentiellement indésirables
              src={ab9}
              alt=""
            />
            <p className="font-openSans text-[16px] max-sm:text-sm max-sm:text-center text-center font-bold text-white opacity-90 leading-6">
              Les Années 80
              <br /> C’était mieux avant - Vol.4 (Compilation)
            </p>
            <span className="max-sm:mx-auto news-link">
              <a
                href="https://www.fnac.com/a21386078/Collectif-Les-Annees-80-C-etait-mieux-avant-Tubes-retrouves-Le-Retour-Volume-4-CD-album"
                rel="noopener noreferrer"
                target="_blank"
              >
                Acheter
              </a>
            </span>
          </li>
        </ul>
      </div>

      <div className="flex justify-center my-9">
        <ul className="flex gap-7 max-sm:flex-col max-lg:flex-col">
          <li className="flex flex-col items-center gap-3">
            <img
              className="max-w-[300px]"
              onContextMenu={preventDefaultActions} // Empêche le clic droit
              onDragStart={preventDefaultActions} // Empêche le glisser-déposer
              onMouseDown={preventDefaultActions} // Empêche d'autres actions de souris potentiellement indésirables
              src={ab10}
              alt=""
            />
            <p className="font-openSans text-[16px] max-sm:text-sm max-sm:text-center text-center font-bold text-white opacity-90 leading-6">
              Kannelle
              <br />
              <span className="italic">Beau comme une femme</span> (EP)
            </p>
            <span className="max-sm:mx-auto news-link">
              <a
                href="https://open.spotify.com/intl-fr/artist/4WBpfxLYzugazMehBpU8lC"
                rel="noopener noreferrer"
                target="_blank"
              >
                Écouter
              </a>
            </span>
          </li>
          <li className=" flex flex-col items-center gap-3">
            <img
              className="max-w-[300px] "
              onContextMenu={preventDefaultActions} // Empêche le clic droit
              onDragStart={preventDefaultActions} // Empêche le glisser-déposer
              onMouseDown={preventDefaultActions} // Empêche d'autres actions de souris potentiellement indésirables
              src={ab11}
              alt=""
            />
            <p className="font-openSans text-[16px] max-sm:text-sm max-sm:text-center text-center font-bold text-white opacity-90  leading-6">
              Marine
              <br />
              <span className="italic">Groupie de Stars</span> (EP)
            </p>
            <span className="max-sm:mx-auto news-link">
              <a
                href="https://open.spotify.com/intl-fr/artist/5qHdfDvq5oXeQeRlgtk2Ka"
                rel="noopener noreferrer"
                target="_blank"
              >
                Écouter
              </a>
            </span>
          </li>
        </ul>
      </div>
      <div
        className="text-center max-w-15 italic font-semibold text-[20px]
        my-5"
      >
        <h2>
          {" "}
          <div className="flex flex-col items-center">
            <span className="text-white max-sm:text-[20px] mt-[80px] max-sm:mt-3">
              Pour les éditions, nous vous invitons à consulter notre répertoire
              en ligne
            </span>
          </div>
        </h2>
        <span className="max-sm:mx-auto news-link">
          <a
            href="https://repertoire.sacem.fr/resultats?filters=parties&query=vincent%20fernandel%20production#searchBtn"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img className="max-w-[100px] h-auto" src={logoSacem} alt="" />
          </a>
        </span>
      </div>
    </div>
  );
};

export default TheProduction;
